/**
 * newsletter.js — wirtschaft. am markt
 * ---------------------------------------------------------------------------
 * Interest checkboxes of the footer sign-up. Shopify's customer form carries
 * exactly one `contact[tags]` value — two inputs of that name would overwrite
 * each other, only the last one survives the POST. The checkboxes are
 * therefore pure UI (no `name`, never submitted on their own) and their state
 * is mirrored into the hidden tags field as a comma-separated list.
 *
 * Without JS the hidden field keeps its rendered default, so the form still
 * subscribes — just with the default interest.
 *
 * HTML has no "at least one of this group" constraint, so while nothing is
 * ticked every box is marked required: the browser then asks for a pick on
 * its own, and ajax-form.js's checkValidity() sees the same thing.
 */

(() => {
  "use strict";

  function initForm(form) {
    if (form.dataset.newsletterReady) return;
    form.dataset.newsletterReady = "true";

    var field = form.querySelector("[data-newsletter-tags]");
    var boxes = Array.prototype.slice.call(form.querySelectorAll("[data-newsletter-interest]"));
    if (!field || !boxes.length) return;

    function sync() {
      var picked = boxes.filter(function (box) {
        return box.checked;
      });
      field.value = picked
        .map(function (box) {
          return box.value;
        })
        .join(",");
      boxes.forEach(function (box) {
        box.required = picked.length === 0;
      });
    }

    boxes.forEach(function (box) {
      box.addEventListener("change", sync);
    });

    // The form keeps its values on a bfcache restore, so read the boxes
    // instead of assuming the rendered default.
    sync();
  }

  function initAll(scope) {
    scope.querySelectorAll("[data-newsletter-form]").forEach(initForm);
  }

  initAll(document);

  document.addEventListener("shopify:section:load", function (event) {
    initAll(event.target);
  });
})();
